import { styled } from '@linaria/react';

import { fonts, primitives, semantic } from '../../theme/tokens';

export const ErrorText = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.danger};
`;
